import { render, staticRenderFns } from "./yesMarkdown.vue?vue&type=template&id=4d83c76f"
import script from "./yesMarkdown.vue?vue&type=script&lang=js"
export * from "./yesMarkdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports